module.exports = require("/tmp/build_3197a04f/src/lib/gatsby/gatsby-browser.tsx");